export enum DropdownCardMenu {
    RENAME = 'RENAME',
    CLONE_INTO_COMMUNITY = 'CLONE_INTO_COMMUNITY',
    DELETE_CARD = 'DELETE_CARD',
    REPEAT_CARD = 'REPEAT_CARD',
    SHARE_LIST = 'SHARE_LIST',
    MAKE_READY = 'MAKE_READY',
    CHANGE_TREE = 'CHANGE_TREE'

}